module.exports = __webpack_public_path__ + "static/service1-d19591d6ede9f5d4440b14e382399399.png";